import { register } from '../../../JavaScript/Utils'

const NewsletterTeaser = el => {
  const form = el.querySelector('.newsletter-teaser-form')
  const messageOutputSuccess = el.querySelector('.message-output-success')
  const messageOutputError = el.querySelector('.message-output-error')
  const formAction = form.action
  const onFormSubmit = e => {
    e.preventDefault()
    const data = new FormData(form) // eslint-disable-line no-undef
    fetch(formAction, { // eslint-disable-line no-undef
      method: 'POST',
      body: data
    })
      .then((response) => response.json())
      .then(() => {
        form.remove()
        messageOutputSuccess.classList.add('is--active')
      })
      .catch(() => {
        messageOutputError.classList.add('is--active')
      })
  }
  form.addEventListener('submit', onFormSubmit)
}

register('NewsletterTeaser', NewsletterTeaser)
